export default [
  {
    path: "/temp-ngo",
    name: "temp-ngo",
    redirect: "/temp-ngo/temp-account-info",
    component: () => import("./moduleLayout.vue"),
    meta: {
      temp: true,
    },
    children: [
      {
        path: "temp-account-info",
        name: "temp-account-info",
        component: () => import("./pages/account-info/index.vue"),
        meta: {
          pageTitle: "ملف المنظمة ",
          temp: true,
          instructionsSlug: "establishment-transaction-account-info",
          breadcrumb: [
            {
              text: "معلومات الحساب",
              active: true,
            },
          ],
        },
      },
      {
        path: "temp-ngo-info",
        name: "temp-ngo-info",
        component: () => import("./pages/ngo-info/index.vue"),
        meta: {
          pageTitle: "ملف المنظمة",
          temp: true,
          instructionsSlug: "establishment-transaction-ngo-info",
          breadcrumb: [
            {
              text: "معلومات المنظمة",
              active: true,
            },
          ],
        },
      },
      {
        path: "temp-founders-info",
        name: "temp-founders-info",
        component: () => import("./pages/founders-info/index.vue"),
        meta: {
          pageTitle: "ملف المنظمة ",
          temp: true,
          instructionsSlug: "establishment-transaction-founding-members",
          breadcrumb: [
            {
              text: "الأعضاء المؤسسين",
              active: true,
            },
          ],
        },
      },
      {
        path: "ministry-track",
        name: "ministry-track",
        component: () => import("./pages/ministry-track/index.vue"),
        meta: {
          pageTitle: "ملف المنظمة ",
          temp: true,
          instructionsSlug: "establishment-transaction-transaction-flow",

          breadcrumb: [
            {
              text: "سير المعاملة",
              active: true,
            },
          ],
        },
      },
      {
        path: "docs-upload",
        name: "docs-upload",
        component: () => import("./pages/docs-upload/index.vue"),
        meta: {
          pageTitle: "ملف المنظمة",
          temp: true,
          instructionsSlug: "establishment-transaction-establishment-docs",
          breadcrumb: [
            {
              text: "وثائق التأسيس",
              active: true,
            },
          ],
        },
      },
    ],
  },
];
